<template>
  <div class="d-flex justify-content-center align-items-center flex-column mt-5">
    <img class="w-25" style="max-width: 250px;" src="@/assets/images/misc/qr-code.png" @click="scanQR" />
    <el-button type="primary" class="w-25 mt-3" style="min-width: 250px" @click="scanQR">
      {{ $t('general.scan_for_articlenumber') }}
    </el-button>
    <div v-if="message">
      {{ message }}
    </div>
  </div>
</template>

<script>
import { Plugins } from '@capacitor/core';
import DetailProductModal from '../../components/modals/DetailProductModal';
export default {
  name: 'QRScanView',
  components: {},
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      scanner: null,
      message: '',
    };
  },
  computed: {},
  methods: {
    async scanQR() {
      this.message = '';
      const { CapacitorQRScanner } = Plugins;
      try {
        let result = await CapacitorQRScanner.scan({});
        this.message = this.$t('messages.qr_found_searching');
        let query = new this.$parse.Query('Product');
        query.equalTo('articleNumber', result.code);
        query.equalTo('language', this.$parse.User.current().get('language'));
        let product = await query.first();

        if (!product) {
          this.message = this.$t('messages.product_not_found');
          return;
        }
        this.message = '';
        this.$modal.show(
          DetailProductModal,
          { productId: parseInt(product.get('modxId')) },
          { height: 'auto', width: '90%', minWidth: 300, maxWidth: 600 }
        );
      } catch (e) {
        console.error(JSON.stringify(e));
        this.message = '';
      }
    },
  },
};
</script>

<style scoped></style>
